import { render, staticRenderFns } from "./AdminContacts.vue?vue&type=template&id=6c0686ce"
import script from "./AdminContacts.vue?vue&type=script&lang=js"
export * from "./AdminContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports